import { inject, Injectable } from '@angular/core';
import { KeyPoint, LocalData, Training } from './app.types';
import { addSeconds, format, setDefaultOptions } from 'date-fns';
import { it } from 'date-fns/locale';
import { ApiService } from './api.service';
setDefaultOptions({ locale: it })
import { Haptics, ImpactStyle } from '@capacitor/haptics';
import { Capacitor } from '@capacitor/core';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class UtilsService {

  startY = 0
  offsetY = 0
  isDragging = false
  api = inject(ApiService)

  private timerSubject = new ReplaySubject<number>(1)
  private timerInterval: ReturnType<typeof setInterval>

  constructor() { }

  public get timerStateChange$(): Observable<number> {
    return this.timerSubject.asObservable()
  }

  startTimer() {
    if(this.timerInterval) return

    this.timerInterval = setInterval(() => {
      const d = Math.round(Date.now() /1000)
      this.timerSubject.next(d)
    }, 1000);
  }

  stopTimer() {
    if(this.timerInterval) {
      clearInterval(this.timerInterval)
    }
  }

  async getLocalData(t: Training, uid: string) {

    if (!uid) {
      uid = this.api.tempUid
    }

    const ldres = await this.api.getLocalData(t.tid, uid)
    if (ldres.localData) {
      return ldres.localData
    } else {
      return {
        elapsed: 0,
        quizCompleted: false,
        videoCompleted: false,
        prize: 0,
        accepted: false,
        location: undefined,
        userData: {
          responses: []
        }
      } as LocalData
    }


  }

  async saveLocalData(tid: number, uid: string, ld: LocalData) {
    await this.api.saveLocalData(tid, uid ? uid : this.api.tempUid, ld)

    // await Preferences.set({
    //   key: tid + "",
    //   value: JSON.stringify(ld)
    // })
  }

  setPrimaryBg(target: HTMLElement) {
    target.classList.add("button-primary-bg")
  }



  setFocus(elid: string) {
    const el = document.getElementById(elid)
    if (el) {
      el.focus()
      el.scrollIntoView({ behavior: "smooth" })
    }
  }

  setClasses(elid: string, classes: string[]) {
    const el = document.getElementById(elid)
    if (el) {
      el.classList.add(...classes)
    }
  }

  readableMinSec(time: number) {
    const roundedTime = Math.round(time);
    const date = addSeconds(new Date(0), roundedTime);
    return format(date, 'mm:ss');
  }

  keypointDuration(kp: KeyPoint) {
    const sec = kp.end! - kp.begin!
    if (sec < 60) {
      return `${Math.round(sec)}sec`
    } else {
      return this.readableMinSec(sec)
    }

  }

  stopFullscreen() {

    document.body.classList.remove("no-scroll")

    document.getElementById("video-header").classList.toggle("hidden")
    document.getElementById("video-footer").classList.toggle("hidden")
    document.getElementById("kp-panel-footer").classList.toggle("hidden")

    const v = document.getElementById("main-video") as HTMLVideoElement
    v.classList.remove("fs")

    const p = document.getElementById("kp-panel") as HTMLElement
    p.classList.remove("fs-panel")
    p.classList.add("hidden")

    const pclose = document.getElementById("cancel-button") as HTMLElement
    pclose.classList.add("hidden")

  }

  safeBottomValue = 0
  goFullScreen() {

    document.getElementById("video-header").classList.toggle("hidden")
    document.getElementById("video-footer").classList.toggle("hidden")
    document.getElementById("kp-panel-footer").classList.toggle("hidden")

    const v = document.getElementById("main-video") as HTMLVideoElement
    v.classList.add("fs")

    const p = document.getElementById("kp-panel") as HTMLElement
    p.classList.remove("hidden")
    p.classList.add("fs-panel")

    // const safeBottom = getComputedStyle(document.documentElement).getPropertyValue('--ion-safe-area-bottom').trim()
    // this.safeBottomValue = parseFloat(safeBottom)
    // p.style.top = (v.clientHeight) - (70+this.safeBottomValue) + "px"

    const pclose = document.getElementById("cancel-button") as HTMLElement
    pclose.classList.remove("hidden")

    
    document.body.classList.add("no-scroll")
  }

  impact() {
    if (Capacitor.isNativePlatform()) {
      Haptics.impact({ style: ImpactStyle.Light })
    }

  }
}
